<template>
  <button
    class="link-button"
    data-external="conversation-card-link-button"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <FriedH5 v-if="isBold">{{ text }}</FriedH5>
    <FriedParagraph v-else :size="ParagraphSize.Small">{{ text }}</FriedParagraph>
    <FriedIcon v-if="icon" :size="IconSize.Small" :icon="icon" />
  </button>
</template>

<script lang="ts">
import type { IconName } from '@getaccept/fried-tofu';
import { IconSize, ParagraphSize } from '@getaccept/fried-tofu';
import type { PropType } from 'vue';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String as PropType<IconName>,
      default: null,
    },
    isBold: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
    },
  },
  emits: ['click'],
  setup() {
    return {
      ParagraphSize,
      IconSize,
    };
  },
});
</script>
<style lang="scss" scoped>
.link-button {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-50);
  background: none;
  border: none;
  padding: 0;
  text-decoration: none;
  outline: none;
  cursor: pointer;

  &:focus[data-focus-visible-added],
  &:hover {
    color: var(--link-blue);
    text-decoration: underline;
  }

  &:disabled {
    text-decoration: none;
    cursor: default;

    > * {
      color: $gray-80;
    }
  }
}
</style>
